<div class="wrap">
    <span [innerHTML]="data.message | translate:data.variables"></span>
    <ic-button (click)="close()" size="small" theme="bordered">{{ 'BUTTON.CLOSE' | translate }}</ic-button>
</div>